<template>
  <div>
    <v-dialog
      v-model="$store.state.dialog"
      width="50%"
      :fullscreen="isfullscreen"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card flat class="px-4 pt-4">
        <!-- dialog toolbar -->
        <v-toolbar height="50" flat>
          <h5>
            {{
              $store.state.itemDetails.dialogType == "add" ? "إضافة" : "تعديل"
            }}
            {{ this.$route.meta.single }}
          </h5>
          <v-spacer />
          <!-- <v-btn small icon fab color="" @click="isfullscreen = !isfullscreen">
                        <v-icon small>{{ isfullscreen ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon>
                    </v-btn> -->
          <v-btn
            @click="close()"
            fab
            small
            icon
            color="grey"
            :disabled="$global.state.loading"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider class="mx-4" />

        <!-- form body -->
        <v-form
          @submit.prevent="submit()"
          ref="form"
          lazy-validation
          v-model="valid"
        >
          <v-container>
            <v-card flat class="py-4 px-1">
              <v-row>
                <v-col cols="12" md="12">
                  <h6 class="mb-1">
                    السؤال
                    <span class="required">*</span>
                  </h6>
                  <v-text-field
                    v-model="body.qn"
                    :rules="[$global.state.required()]"
                    required
                    outlined
                    hide-details="auto"
                    filled
                    dense
                    placeholder="السؤال"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <h6 class="mb-1">
                    الجواب
                    <span class="required">*</span>
                  </h6>
                  <v-text-field
                    v-model="body.ansswer"
                    :rules="[$global.state.required()]"
                    required
                    outlined
                    hide-details="auto"
                    filled
                    dense
                    placeholder="الجواب"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider class="ml- mt-8" />

              <!-- actions -->
              <div class="mt-4">
                <v-btn
                  type="submit"
                  :loading="$global.state.loading"
                  color="primary"
                  class="btn"
                  :disabled="!valid"
                >
                  حفظ
                  <v-icon small right>fi fi-rr-disk</v-icon>
                </v-btn>
                <v-btn
                  @click="close()"
                  text
                  class="mr-2 btn"
                  :disabled="$global.state.loading"
                >
                  إلغاء
                </v-btn>
              </div>
            </v-card>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    isfullscreen: false,
    valid: true,
    body: {},
  }),

  created() {
    this.reset();
  },

  mounted() {
    this.$eventBus.$on("fill-fields", () => {
      this.body = this.$store.state.itemDetails;
    });
  },

  methods: {
    reset() {
      this.body = {
        qn: "",
        ansswer: "",
      };
    },

    submit() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        if (this.$store.state.itemDetails.dialogType == "add") {
          this.addItem();
        } else {
          this.editItem();
        }
      }
    },

    async addItem() {
      this.$global.state.loading = true;
      await this.$http
        .post(`${this.$route.meta.endPoint}`, this.body)
        .then((res) => {
          this.$emit(`refresh`);
          this.close();
          this.$store.dispatch("toastification/setToast", {
            message: `${res.data.message}`,
            type: "success",
          });
        })
        .catch((err) => {
          this.$store.dispatch("toastification/setToast", {
            message: `${err.data.message}`,
            type: "error",
          });
        })
        .finally(() => (this.$global.state.loading = false));
    },

    async editItem() {
      this.$global.state.loading = true;
      await this.$http
        .put(`${this.$route.meta.endPoint}/${this.body.id}`, this.body)
        .then((res) => {
          this.close();
          this.$store.dispatch("toastification/setToast", {
            message: `${res.data.message}`,
            type: "success",
          });
          this.$eventBus.$emit(this.$route.path);
        })
        .catch((err) => {
          this.$store.dispatch("toastification/setToast", {
            message: `${err.data.message}`,
            type: "error",
          });
        })
        .finally(() => (this.$global.state.loading = false));
    },

    close() {
      this.$store.commit("setDialog");
      this.reset();
      this.resetValidation();
      this.$store.commit("setItemDetails", {});
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
